/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   import IPromise = angular.IPromise;
   import IQService = angular.IQService;
   import HostListItemData = com.vmware.vsphere.client.dvs.api.host.HostListItemData;
   import DvsNewHostsData = com.vmware.vsphere.client.h5.network.dvs.addhost.model.DvsNewHostsData;

   export class DvsSelectHostsPageController {

      private static readonly NEW_HOSTS_DATA_PROP: string = "dvs:newHostsData";

      public static $inject =
            ["$scope",
               "dataService",
               "$q"];

      constructor(private $scope: DvsAddHostWizardScope,
                  private dataService: any,
                  private $q: IQService) {
      }

      private allHosts: HostListItemData[];

      public onHostsChanged(addedHosts: HostListItemData[]): void {
         this.$scope.model.selectHostsPageModel.hosts = addedHosts;
      }

      public requestHosts(): IPromise<HostListItemData[]> {
         if (!this.allHosts) {
            return this.dataService.getProperties(
                  this.$scope.model.dvsId,
                  [DvsSelectHostsPageController.NEW_HOSTS_DATA_PROP])
                  .then((response: any): HostListItemData[] => {
                     let data: DvsNewHostsData = response[DvsSelectHostsPageController.NEW_HOSTS_DATA_PROP];
                     if (data) {
                        this.allHosts = data.hosts;
                     } else {
                        this.allHosts = [];
                     }
                     return this.allHosts;
                  });
         } else {
            return this.$q.when(this.allHosts);
         }
      }
   }

   angular.module("com.vmware.vsphere.client.dvs")
         .controller("DvsSelectHostsPageController", DvsSelectHostsPageController);
}
